import { render, staticRenderFns } from "./NormalSearchNav519.vue?vue&type=template&id=afae721a&scoped=true"
import script from "./NormalSearchNav519.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav519.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afae721a",
  null
  
)

export default component.exports